module.exports = __webpack_public_path__ + "static/media/jm.f53e2aaf.svg";